import React, { useState } from "react";
import { Box, Button, Input, Typography } from "@mui/material"

function DynaGrid({row, col, onClick}) {
  // State to manage the number of rows and columns
  const [rows, setRows] = useState(row);
  const [cols, setCols] = useState(col);
  onClick = onClick?onClick:()=>{}

  // Generate grid items based on rows and columns
  const gridItems = Array.from({ length: rows * cols }, (_, index) => index + 1);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "16px",
        backgroundColor: "background.level1",
        cursor:'pointer'
       
        
      }}
      onClick={onClick}
      
    >

      {/* Grid Container */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "2px",
          width: "26px",
        }}
      >
        {gridItems.map((item) => (
          <Box
            key={item}
            sx={{
              flex: `1 1 calc(${100 / cols}% - 2px)`, // Dynamic width based on columns
              position: "relative",
              paddingTop: `calc(${100 / cols}% - 2px)`, // Maintain 1:1 aspect ratio
              borderRadius: "100%",
              backgroundColor: "#218b55",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#fff",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default DynaGrid;